import { render, staticRenderFns } from "./TransactionAttachmentDetail.vue?vue&type=template&id=7b085900&scoped=true&"
import script from "./TransactionAttachmentDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionAttachmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b085900",
  null
  
)

export default component.exports